import { Col, Container, Row } from "react-grid-system"
import styled from "styled-components"
import { BsFillArrowRightCircleFill } from 'react-icons/bs'
import { IoIosArrowDown } from 'react-icons/io'
import colors from "../../assets/colors/colors"
import FullScreen from "./FullScreen"
import Card from "./Card"
import { useEffect, useState } from "react"
import { HiOutlineArrowsExpand } from "react-icons/hi"
import ModalInfoCard from "./ModalInfoCard"
import NumberFormat from "react-number-format"

interface Props {
    menu: {
        name: string
        description: string
        items: any
    },
    id_restaurant: any
    colors?: any
}

interface StyledInterface {
    color: any
}


export default function PostsCategories(props: Props) {
    const { name: sectionName, items: menus } = props.menu


    const [openSection, setOpenSection] = useState<any>(false)
    const [dataModal, setDataModal] = useState<any>(null)
    const [previewSection, setPreview] = useState([])

    useEffect(() => {
        preview()
    }, [])

    const handleOpenSection = () => {
        let open = openSection
        setOpenSection(open = !open)
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "initial";
        }
    }

    const closeFullScreen = () => {
        setOpenSection(false)
        document.body.style.overflow = "initial";
    }

    const preview = () => {
    }

    const amount = menus.length

    const openModalInfo = (data: any) => {
        setDataModal(data);
        setOpenSection(true)
    }

    return (
        <>
            <Content color={colors}>
                <section>
                    <Row align="center">
                        <Col>
                            <Row>
                                <Col xs={10}>
                                    <h3><b>{sectionName}</b></h3>
                                </Col>
                                <Col xs={2}>
                                    <IoIosArrowDown style={{ fontSize: "1.5em" }} />
                                </Col>
                            </Row>
                        </Col>
                        <ul>
                            {
                                previewSection.map((item: any, index: any) => (
                                    <li>{item.name}...</li>
                                ))
                            }
                        </ul>
                    </Row>
                </section>
            </Content>
            {openSection && (
                <ModalInfoCard closeModal={() => setOpenSection(false)}
                    data={dataModal}
                />
            )}
            <ContentPosts style={{ overflowX: amount > 2 ? "auto" : "hidden" }}>
                {
                    menus && menus.map((dt: any, index: any) => (
                        <CardNew
                            onClick={() => openModalInfo(dt)}
                        >
                            <div className="contentImage">
                                <img
                                    src={
                                        dt.image
                                        || "https://i.postimg.cc/PrdVR20x/placeholder-image.png"}
                                    alt="" />
                            </div>
                            <div className="contentText">
                                <h5>
                                    {dt.name.substr(0, 30) || 'Sin nombre'}
                                </h5>
                                {props.colors ? (
                                    <p
                                        style={{
                                            color: props.colors && props.colors.colors2
                                        }}
                                    >
                                        RD$
                                        <NumberFormat
                                            thousandsGroupStyle="thousand"
                                            value={dt.price || "0.0"}
                                            prefix=""
                                            decimalSeparator="."
                                            displayType="text"
                                            type="text"
                                            thousandSeparator={true}
                                            allowNegative={true} />
                                    </p>
                                )
                                    : (
                                        <p className="text-success pricing">
                                            RD$
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={dt.price || "0.0"}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true} />
                                        </p>
                                    )
                                }
                            </div>
                        </CardNew>
                    ))
                }
            </ContentPosts>
        </>
    )
}


const ContentPosts = styled.div`
    width: 400px;
    white-space:nowrap;
    ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 0;
        height: 0;
    }
`

const CardNew = styled.div`
    position:relative;
    width: 250px;
    background-color: white;
    display: inline-block;
    white-space: pre-wrap ;
    margin:  0 0.5em ;
    border: 1px solid #dfdfdf;
    border-radius: 10px;
    .contentText{
        padding: 1em;
        h5 {
        }
    }
    .contentImage{
        padding: 1em;
        text-align:center;
        img {
            width: 200px;
            height: 150px;
            object-fit:contain;
        }
    }

`
const Content = styled.div<StyledInterface>`
        background: white;
        /* border: 1px solid ${props => props.color.white01}; */
        border-radius: 12px;
        margin: 1em 1em;
        section {
            position: relative;
            padding: 1.4em 0;
            ul {
                position: absolute;
                left: 0;
                list-style: none;
                margin: 0 !important;
                padding: 0 1em!important;
                display: flex;
                flex-direction:row;
                white-space: pre;
                li {
                    white-space: pre;
                    margin: 0 0.2em;
                    color: #31313157;
                }
            }
            h4 {
                margin: 0 !important;
            }
            .icon {
                font-size: 1.5em;
                color: ${props => props.color.blue};
            }
        }
        /* .secciones {
            width: 100%;
            padding: 1em 0.5em;
            overflow-y: hidden;
            overflow-x: auto;
            white-space: nowrap; 
            .guide{
                width: 100%;
                text-align: center;
                font-size: 1em;
                p{
                  position: absolute;
                    right: 1em;
                }
            }
        } */


`